import { render, staticRenderFns } from "./WipeCache.vue?vue&type=template&id=02c64e90&scoped=true&"
import script from "./WipeCache.vue?vue&type=script&lang=js&"
export * from "./WipeCache.vue?vue&type=script&lang=js&"
import style0 from "./WipeCache.vue?vue&type=style&index=0&id=02c64e90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c64e90",
  null
  
)

export default component.exports